import { render, staticRenderFns } from "./pendingRisks.vue?vue&type=template&id=151ff6ce&scoped=true&"
import script from "./pendingRisks.vue?vue&type=script&lang=js&"
export * from "./pendingRisks.vue?vue&type=script&lang=js&"
import style0 from "./pendingRisks.vue?vue&type=style&index=0&id=151ff6ce&prod&scoped=true&lang=css&"
import style1 from "./pendingRisks.vue?vue&type=style&index=1&id=151ff6ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ff6ce",
  null
  
)

export default component.exports